import React, { Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Link, withRouter } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import ErrorMessage from '../../components/errormessage';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import { enforceSlash } from '../../utils/helpers';
import { Table, Tr, Td, Th, Thead } from 'reactable';
import { ThemedButton } from '../../components/themed/ThemedComponents';

@inject('superStore')
@observer
class QuestionsContainer extends React.Component {
    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        await this.props.superStore.loadQuestions();
    }

    render() {
        const { loadingQuestions, questions, questionsError } =
            this.props.superStore;
        const { match } = this.props;

        return loadingQuestions ? (
            <ThemedSpinner />
        ) : (
            <Fragment>
                <ErrorMessage error={questionsError} />

                <Row>
                    <Col md="12" xs="12" className="right">
                        <div className="action">
                            <Link to={`${enforceSlash(match.url)}create`}>
                                <ThemedButton secondary>
                                    Create new
                                </ThemedButton>
                            </Link>
                        </div>
                    </Col>
                </Row>

                <Row>
                    {questions && questions.length > 0 && (
                        <Col md="12" xs="12" className="leftMenu">
                            <Table className="table slim" id="table">
                                <Thead>
                                    <Th column="Id" className="">
                                        Id
                                    </Th>
                                    <Th column="Name" className="">
                                        Native Name
                                    </Th>
                                    <Th column="public" className="">
                                        Public{' '}
                                    </Th>
                                    <Th column="Order" className="">
                                        order
                                    </Th>
                                </Thead>
                                {questions.map((q, i) => (
                                    <Tr key={q.id}>
                                        <Td
                                            column={'Id'}
                                            value={q.id}
                                            className=""
                                        >
                                            <Link
                                                to={`${enforceSlash(
                                                    match.url
                                                )}${q.id}/edit`}
                                            >
                                                {q.id}
                                            </Link>
                                        </Td>
                                        <Td column={'Name'} value={q.name}>
                                            <Link
                                                to={`${enforceSlash(
                                                    match.url
                                                )}${q.id}/edit`}
                                            >
                                                {q.name}
                                            </Link>
                                        </Td>

                                        <Td column={'public'} value={q.name}>
                                            <Fragment>
                                                {q.isPublic > 0 ? (
                                                    <span
                                                        className={
                                                            'flag static-flag '
                                                        }
                                                        style={{
                                                            backgroundImage: `url(/static/img/icon-completed.png)`,
                                                        }}
                                                    >
                                                        &nbsp;
                                                    </span>
                                                ) : (
                                                    <span
                                                        className={
                                                            'flag static-flag '
                                                        }
                                                        style={{
                                                            backgroundImage: `url(/static/img/icon-close.png)`,
                                                        }}
                                                    >
                                                        &nbsp;
                                                    </span>
                                                )}
                                            </Fragment>
                                        </Td>
                                        <Td column={'Order'} value={q.order}>
                                            {q.order_number}
                                        </Td>
                                    </Tr>
                                ))}
                            </Table>
                        </Col>
                    )}
                </Row>
            </Fragment>
        );
    }
}

export default withRouter(QuestionsContainer);
